const env = import.meta.env;

const buildNumber = env.VITE_CODEBUILD_BUILD_NUMBER;
const sentryEnv = env.VITE_SENTRY_ENV;
const wafCaptcha = env.VITE_WAF_API_URL;
const wafApiKey = env.VITE_WAF_API_KEY;
const tenantId = env.VITE_TENANT_ID;

if (!tenantId) {
  throw new Error('VITE_TENANT_ID environment variable is required');
}

export const Config = {
  /** Tenant ID for library APIs. */
  tenantId,
  /** Base URL for API. */
  baseURL: env.VITE_BASE_URL,
  /** AWS WAF */
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
  /** Sentry  configuratiin **/
  sentry: {
    env: sentryEnv,
    dsn: env.VITE_SENTRY_DSN,
    release:
      sentryEnv && buildNumber ? `${sentryEnv}-${buildNumber}` : undefined,
  },
};
